export const SUPPORTED_LANGUAGES = ['en', 'pt-br'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'pt-br';

export type TranslatableDict = Record<SupportedLanguage, string>;

export type TranslatableField = string | TranslatableDict;
